import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-8 text-center border border-slate-200">
        <XCircle className="h-12 w-12 text-slate-400 mx-auto" />
        <h1 className="font-heading text-xl font-bold text-slate-900 mt-4">Checkout cancelled</h1>
        <p className="text-slate-500 mt-2">No charge was made. You can pick up where you left off any time.</p>
        <div className="mt-6 flex gap-3 justify-center">
          <Button variant="outline" onClick={() => navigate("/pricing")} className="rounded-full">View Plans</Button>
          <Button onClick={() => navigate("/free-scan")} className="rounded-full bg-indigo-600 hover:bg-indigo-700">Scan Free</Button>
        </div>
      </div>
    </div>
  );
}
